import { randomBytes, createCipheriv, createDecipheriv } from "crypto";
import config from "@/lib/config";
import connectRedis from "@/lib/connectRedis";
import jwt from "jsonwebtoken";
export default class MySkpToken {
  constructor(req, res) {
    var _config$myskpToken$re, _config$myskpToken$re2, _config$myskpToken$re3, _config$myskpToken;
    this.req = req;
    this.res = res;
    this.redis = connectRedis({
      host: process.env.REDIS_HOST || ((_config$myskpToken$re = config.myskpToken.redis) === null || _config$myskpToken$re === void 0 ? void 0 : _config$myskpToken$re.host),
      port: process.env.REDIS_PORT || ((_config$myskpToken$re2 = config.myskpToken.redis) === null || _config$myskpToken$re2 === void 0 ? void 0 : _config$myskpToken$re2.port),
      keyPrefix: config.myskpToken.redis.prefix,
      db: (_config$myskpToken$re3 = config.myskpToken.redis) === null || _config$myskpToken$re3 === void 0 ? void 0 : _config$myskpToken$re3.db
    }, (_config$myskpToken = config.myskpToken) === null || _config$myskpToken === void 0 || (_config$myskpToken = _config$myskpToken.redis) === null || _config$myskpToken === void 0 ? void 0 : _config$myskpToken.cluster);
  }
  generateKey() {
    return randomBytes(32).toString("hex");
  }
  encrypt(payload, key) {
    const iv = randomBytes(16);
    const cipher = createCipheriv("aes-256-ctr", key, iv);
    const encrypted = Buffer.concat([cipher.update(JSON.stringify(payload), "utf-8", "buffer"), cipher.final("buffer")]);
    return Buffer.concat([iv, encrypted]).toString("hex");
  }
  decrypt(payload, key) {
    const buf = Buffer.from(payload, "hex");
    const iv = buf.slice(0, 16);
    const encrypted = buf.slice(16);
    const decipher = createDecipheriv("aes-256-ctr", key, iv);
    const decrypted = Buffer.concat([decipher.update(encrypted), decipher.final()]);
    return decrypted.toString("utf-8");
  }
  async setPayload(payload) {
    const key = this.generateKey();
    await this.redis.multi().set(key, payload).expire(key, config.myskpToken.maxAge).exec();
    return key;
  }
  async getPayload(key) {
    return await this.redis.get(key);
  }
  deletePayload(token) {
    return this.redis.del(token);
  }
  async publish(payload) {
    const encryptionKey = randomBytes(32);
    const encrypted = this.encrypt(payload, encryptionKey);
    const key = await this.setPayload(encrypted);
    return jwt.sign({
      key1: key,
      key2: encryptionKey
    }, config.myskpToken.jwtSecret);
  }
  async verify(token) {
    try {
      const verifiedToken = jwt.verify(token, config.myskpToken.jwtSecret);
      const payload = await this.getPayload(verifiedToken.key1);
      const jsonStr = this.decrypt(payload, Buffer.from(verifiedToken.key2));
      return JSON.parse(jsonStr);
    } catch (e) {
      console.log(e);
      return false;
    }
  }
}